// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    listErights as listErightsAPI,
    getEright as getErightAPI,
    addEright as addErightAPI,
    updateEright as updateErightAPI,
    deleteEright as deleteErightAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { erightApiResponseError, erightApiResponseSuccess } from './actions';
import { ErightsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getEright({ payload: { id } }) {
    try {
        const response = yield call(getErightAPI, id );
        const eright = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(erightApiResponseSuccess(ErightsActionTypes.GET_ERIGHT, eright));
    } catch (error) {
        yield put(erightApiResponseError(ErightsActionTypes.GET_ERIGHT, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listErights() {
    try {
        const response = yield call(listErightsAPI);
        const listaErights = response.data.data;
        
        yield put(erightApiResponseSuccess(ErightsActionTypes.LIST_ERIGHTS, listaErights));
    } catch (error) {
        yield put(erightApiResponseError(ErightsActionTypes.LIST_ERIGHTS, error));
    }
}

function* addEright({payload:eright}){
    try{
        const response = yield call(addErightAPI,{...eright})
        const derecho = response.data.data
        yield put(erightApiResponseSuccess(ErightsActionTypes.ADD_ERIGHT,derecho))
    }catch(error){
        yield put(erightApiResponseError(ErightsActionTypes.ADD_ERIGHT,error))
    }
}

function* updateEright({payload:eright}){
    try{
        const response = yield call(updateErightAPI,{...eright})
        const derecho = response.data.data
        yield put(erightApiResponseSuccess(ErightsActionTypes.UPDATE_ERIGHT,derecho))
    }catch(error){
        yield put(erightApiResponseError(ErightsActionTypes.UPDATE_ERIGHT,error))
    }
}

function* deleteEright({payload:{id}}){
    try{
        const response = yield call(deleteErightAPI,id)
        const eright = response.data.id
        yield put(erightApiResponseSuccess(ErightsActionTypes.DELETE_ERIGHT,eright))
    }catch(error){
        yield put(erightApiResponseError(ErightsActionTypes.DELETE_ERIGHT,error))
    }
}


export function* watchGetEright(): any {
    yield takeEvery(ErightsActionTypes.GET_ERIGHT, getEright);
}

export function* watchListErights(): any {
    yield takeEvery(ErightsActionTypes.LIST_ERIGHTS, listErights);
}

export function* watchAddEright():any{
    yield takeEvery(ErightsActionTypes.ADD_ERIGHT, addEright);
}

export function* watchUpdateEright(): any{
    yield takeEvery(ErightsActionTypes.UPDATE_ERIGHT, updateEright);
}
export function* watchDeleteEright(): any{
    yield takeEvery(ErightsActionTypes.DELETE_ERIGHT, deleteEright);
}


function* erightsSaga(): any {
    yield all([
        fork(watchGetEright),
        fork(watchListErights),
        fork(watchAddEright),
        fork(watchUpdateEright),
        fork(watchDeleteEright),
    ]);
}

export default erightsSaga;
